import { differenceInMinutes } from "date-fns";

const colorPerSeverity = {
  DEBUG: "#ccc4ff",
  INFO: "#6046ff",
  WARNING: "#f1ba33",
  ERROR: "#fc5f53",
  NOTICE: "#6155ad",
  FATAL: "#FF0000"
};

export function severityToColor(severity: string): string {
  switch (severity) {
    case "EMERGENCY":
      return colorPerSeverity["FATAL"];
    case "ALERT":
    case "CRITICAL":
    case "ERROR":
      return colorPerSeverity["ERROR"];
    case "WARNING":
      return colorPerSeverity["WARNING"];
    case "NOTICE":
      return colorPerSeverity["NOTICE"];
    case "INFO":
      return colorPerSeverity["INFO"];
    default:
      return colorPerSeverity["NOTICE"];
  }
}

const every1Minute = (d: Date) => d.getSeconds() == 0;
const every5Minutes = (d: Date) =>
  d.getSeconds() == 0 && d.getMinutes() % 5 == 0;
const every15Minutes = (d: Date) =>
  d.getSeconds() == 0 && d.getMinutes() % 15 == 0;
const every30Minutes = (d: Date) =>
  d.getSeconds() == 0 && d.getMinutes() % 30 == 0;
const every1Hour = (d: Date) => d.getHours() == 0 && d.getMinutes() == 0;
const every3Hours = (d: Date) => d.getHours() % 3 == 0 && d.getMinutes() == 0;
const every6Hours = (d: Date) => d.getHours() % 6 == 0 && d.getMinutes() == 0;
const every12Hours = (d: Date) => d.getHours() % 12 == 0 && d.getMinutes() == 0;
const every1Day = (d: Date) => d.getHours() == 0 && d.getMinutes() == 0;
const every2Days = (d: Date) => d.getDate() % 2 == 0;

export function tickValuesForScaleBand(
  start: Date,
  end: Date
): (d: Date, i: number) => boolean {
  const diffMinutes = differenceInMinutes(end, start);

  if (diffMinutes > 15 * 24 * 60) {
    return every2Days;
  }

  if (diffMinutes > 10 * 24 * 60) {
    return every1Day;
  }

  if (diffMinutes > 7 * 24 * 60) {
    return every12Hours;
  }

  if (diffMinutes > 2 * 24 * 60) {
    return every6Hours;
  }

  if (diffMinutes > 20 * 60) {
    return every3Hours;
  }

  if (diffMinutes > 8 * 60) {
    return every1Hour;
  }

  if (diffMinutes > 4 * 60) {
    return every30Minutes;
  }

  if (diffMinutes > 1 * 60) {
    return every15Minutes;
  }

  if (diffMinutes > 15) {
    return every5Minutes;
  }

  return every1Minute;
}
